// ShellStatusNotice - no longer shown.
// The site always renders as stable with authoritative content.
// This component is kept as a no-op to avoid breaking imports.

export function ShellStatusNotice() {
  return null;
}
